const SHOPPING_CART_ITEMS = 'outletCart';

const outletCartService = {
  getCart() {
    try {
      const raw = localStorage.getItem(SHOPPING_CART_ITEMS);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  },

  setCart(items) {
    localStorage.setItem(SHOPPING_CART_ITEMS, JSON.stringify(items || []));
  },

  addPack(pack) {
    if (!pack || !pack.id) return this.getCart();
    const cart = this.getCart();
    const exists = cart.some((p) => p.id === pack.id);
    if (exists) return cart;
    let clone;
    try {
      clone = JSON.parse(JSON.stringify(pack));
    } catch {
      clone = { ...pack };
      if (pack.PackDetails) clone.PackDetails = [...pack.PackDetails];
      if (pack.Location) clone.Location = { ...pack.Location };
    }
    cart.push(clone);
    this.setCart(cart);
    return cart;
  },

  removePack(packId) {
    const cart = this.getCart().filter((p) => p.id !== packId);
    this.setCart(cart);
    return cart;
  },

  clear() {
    localStorage.removeItem(SHOPPING_CART_ITEMS);
    return [];
  },

  getCount() {
    return this.getCart().length;
  },

  hasPack(packId) {
    return this.getCart().some((p) => p.id === packId);
  },
};

export default outletCartService;
